import React from 'react';
import LiqExhibitTitleContainer from '../../layout/LiqExhibitTitleContainer';
import LoadingUpdates from 'components/generic-dashboards/loading/LoadingUpdates';
import LiqCard from '../../layout/LiqCard';
import { MissingData } from 'components/misc/MissingData';
import { RangedSummary } from '../../../interfaces/text-summary.interface';

const summary = (data: RangedSummary | null, loading: boolean) => {
    return (
        <div>
            {loading ? (
                <LoadingUpdates />
            ) : !loading && !data ? (
                <MissingData />
            ) : data && data.summary ? (
                <p className="list-inside list-disc flex flex-col gap-2">{data.summary}</p>
            ) : (
                <p>No Summary Found</p>
            )}
        </div>
    );
};

const TextSummary = ({
    title = '',
    data,
    loading,
}: {
    title?: string;
    data: RangedSummary | null;
    loading: boolean;
}) => {
    return (
        <div>
            <LiqExhibitTitleContainer
                title={title}
                subtitle={`${
                    data !== null && data.start_date && data.end_date
                        ? `${data.start_date.split('T')[0]} - ${data.end_date.split('T')[0]}`
                        : ''
                }`}
            />
            <hr className="h-0.5 my-3 bg-slate-100 rounded" />
            {loading ? <LoadingUpdates /> : <LiqCard>{summary(data, loading)}</LiqCard>}
        </div>
    );
};

export default TextSummary;
